import BaseAbility from './base-ability';
import {
  PREFIX_INFRAGRAPH,
  ACTION_LIST,
} from '../utils/permission-types/index';
import { variation } from 'ember-launch-darkly';

export default class extends BaseAbility {
  prefix = PREFIX_INFRAGRAPH;

  get canList() {
    const hasPermission = this.permissions.has(this.generate(ACTION_LIST));
    const featureFlagEnabled =
      variation('hcp-ui-infragraph-enabled') ||
      localStorage.getItem('hcp-ui-infragraph-enabled') === 'true';
    return hasPermission && featureFlagEnabled;
  }
}
